import CMSMenuCollection from '@netx/core-cms/collections/CMSMenus';

export const currentPortalMenus = new CMSMenuCollection([], {parse: false});
